import React from "react";
import {
	Box,
	Typography,
	Paper,
	Container,
} from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";

interface AppLockProps {
	message: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function AppLock({ message = "The application is currently locked. Please try again later." }: AppLockProps) {
	return (
		<Container maxWidth="sm">
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					minHeight: "100vh",
					padding: 2,
				}}
			>
				<Paper
					elevation={3}
					sx={{
						padding: 4,
						textAlign: "center",
						width: "100%",
						maxWidth: 400,
					}}
				>
					<LockIcon
						sx={{
							fontSize: 64,
							color: "error.main",
							mb: 2,
						}}
					/>
					<Typography variant="h4" component="h1" gutterBottom color="error">Ограничен достъп</Typography>
					<Typography variant="body1" color="text.secondary">
						{/* eslint-disable-next-line @typescript-eslint/naming-convention */}
						<span dangerouslySetInnerHTML={{ __html: message }} />
					</Typography>
				</Paper>
			</Box>
		</Container>
	);
}

export default AppLock;
